import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "My Dashboard", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "position-relative"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_AnnuityPanel = _resolveComponent("AnnuityPanel")!
  const _component_PensionPanel = _resolveComponent("PensionPanel")!
  const _component_VacationPanel = _resolveComponent("VacationPanel")!
  const _component_FundAlert = _resolveComponent("FundAlert")!

  return ($setup.loading)
    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["section-content", { 'hidden': $setup.modals?.length }])
      }, [
        _hoisted_1,
        ($setup.errorMessage)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString('Internal error, please try again later. If this issues persist please contact the Fund Office.'), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (!$setup.loading)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent($setup.healthComponent), {
                    key: 0,
                    data: $setup.healthData,
                    alerts: $setup.alerts?.Health,
                    hasPlanCUpcomingInvoice: $setup.hasPlanCUpcomingInvoice,
                    hasPlanCCurrentInvoice: $setup.hasPlanCCurrentInvoice,
                    hasPlanCobraCurrentInvoice: $setup.hasPlanCobraCurrentInvoice,
                    hasPlanCobraUpcomingInvoice: $setup.hasPlanCobraUpcomingInvoice,
                    showNextCoverageLink: $setup.showNextCoverageLink,
                    IsAnthemSsoEnabled: $setup.IsAnthemSsoEnabled,
                    onUpcomingCoverage: $setup.upcomingCoverage
                  }, null, 40, ["data", "alerts", "hasPlanCUpcomingInvoice", "hasPlanCCurrentInvoice", "hasPlanCobraCurrentInvoice", "hasPlanCobraUpcomingInvoice", "showNextCoverageLink", "IsAnthemSsoEnabled", "onUpcomingCoverage"]))
                : _createCommentVNode("", true),
              ($setup.annuityData)
                ? (_openBlock(), _createBlock(_component_AnnuityPanel, {
                    key: 1,
                    data: $setup.annuityData,
                    alerts: $setup.alerts?.Annuity || null
                  }, null, 8, ["data", "alerts"]))
                : _createCommentVNode("", true),
              ($setup.pensionData && $setup.pensionData?.ENABLED)
                ? (_openBlock(), _createBlock(_component_PensionPanel, {
                    key: 2,
                    data: $setup.pensionData,
                    alerts: $setup.alerts?.Pension || null
                  }, null, 8, ["data", "alerts"]))
                : _createCommentVNode("", true),
              ($setup.vacationData && $setup.vacationData?.ENABLED)
                ? (_openBlock(), _createBlock(_component_VacationPanel, {
                    key: 3,
                    alerts: $setup.alerts?.Vacation || null
                  }, null, 8, ["alerts"]))
                : _createCommentVNode("", true),
              ($setup.alerts?.General)
                ? (_openBlock(), _createBlock(_component_FundAlert, {
                    key: 4,
                    count: $setup.unreadAlerts,
                    onOpen: $setup.openModal,
                    "class-names": "position-top"
                  }, null, 8, ["count", "onOpen"]))
                : _createCommentVNode("", true)
            ]))
      ], 2))
}